import Title from "./Title";
import React, { useState } from "react";
import ringelblume from "../images/gärtnerei-ringelblume.png";
import inktank from "../images/inktank.png";
import jenseitsDerElbe from "../images/jenseits-elbe1.png";
import { useTranslation } from "react-i18next";

export default function Projects() {
  const { t } = useTranslation();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const items = [
    {
      title: t("gärtnerei-ringelblume-title"),
      link: "https://gaertnerei-ringelblume.de/",
      subtitle: t("gärtnerei-ringelblume-text"),
      image: ringelblume,
    },
    {
      title: t("jenseits-der-elbe-title"),
      link: "https://jenseits-elbe.de/",
      subtitle: t("jenseits-der-elbe-text"),
      image: jenseitsDerElbe,
    },
    {
      title: "InkTank",
      link: "https://www.behance.net/gallery/71996983/Ink-Tank-Tattoo-App-and-Design-Process",
      subtitle: t("ink-tank-text"),
      image: inktank,
    },
  ];

  return (
    <section id={t("link-projects")} className="projects-section section">
      <Title title={t("projects-title")} />

      <div className="container">
        <div className="left-box">
          {items.map((item, index) => (
            <div
              key={index}
              className="item"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <h3>
                <a href={item.link} target="blank">
                  {item.title}
                </a>
              </h3>
              <p>{item.subtitle}</p>
            </div>
          ))}
        </div>
        <div className="right-box">
          {hoveredIndex !== null ? (
            <img src={items[hoveredIndex].image} alt="Vorschau" />
          ) : (
            <img src={items[0].image} alt="Vorschau" />
          )}
        </div>
      </div>
    </section>
  );
}
